import { useTranslation } from "react-i18next";
import { convertNumberFormat, leasingDisclaimer } from "../../utils";
import SVGSelector from "../common-components/SVGSelector";
import Tooltip from "../common-components/Tooltip";
import StyledListItem from "./StyledListItem";

const LeasingTabView = ({ vehicleDetails, currency }) => {
  const { t } = useTranslation();

  return (
    <>
      <ul className="space-y-1 pe-2">
        {vehicleDetails?.leasingOptions?.[0]?.instalment ? (
          <li className="flex justify-end items-end max-sm:block">
            <h4 className="text-2xl font-semibold text-[var(--text-black-white)] max-md:text-lg text-right">
              <span className="text-lg flex justify-end">
                <sup>
                  <Tooltip
                    text={
                      <ul className="space-y-1 pe-2 overflow-auto custom-scrollbar">
                        {vehicleDetails?.leasingOptions?.[0]?.notes ||
                        leasingDisclaimer ? (
                          <StyledListItem
                            notes={
                              vehicleDetails?.leasingOptions?.[0]?.notes
                                ? vehicleDetails?.leasingOptions?.[0]?.notes
                                : leasingDisclaimer({
                                    t,
                                    nameOfBank:
                                      vehicleDetails?.leasingOptions?.[0]
                                        ?.nameOfBank,
                                  })
                            }
                            isTooltipContent={true}
                          />
                        ) : null}
                      </ul>
                    }
                    className={
                      "text-ellipsis break-words text-[var(--davy-gray-color)] pt-2"
                    }
                    spanClassName={
                      "!w-[20rem] text-left max-sm:w-[18rem]  max-sm:text-xs max-sm:left-[2rem]"
                    }
                  >
                    <SVGSelector name="i-svg" />
                  </Tooltip>
                </sup>
                {t("/vehicles.Leases/month")}
              </span>{" "}
              <span className="text-4xl">
                {convertNumberFormat(
                  vehicleDetails?.leasingOptions?.[0]?.instalment,
                  currency,
                )}
              </span>
            </h4>
          </li>
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.financedAmount ? (
          <StyledListItem
            label={t("/vehicleDetails.Net loan amount")}
            value={convertNumberFormat(
              vehicleDetails?.leasingOptions?.[0]?.financedAmount,
              currency,
            )}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.mileagePerYear ? (
          <StyledListItem
            label={t("/vehicleDetails.Mileage p.a.")}
            value={`${convertNumberFormat(vehicleDetails?.leasingOptions?.[0]?.mileagePerYear)} km`}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.leasingLowMileageCompensation ? (
          <StyledListItem
            label={t("/vehicleDetails.Less kilometers")}
            value={`${convertNumberFormat(vehicleDetails?.leasingOptions?.[0]?.leasingLowMileageCompensation)}
          ${t("/vehicleDetails.cents")}`}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.leasingExtraMileageCosts ? (
          <StyledListItem
            label={t("/vehicleDetails.Additional kilometers")}
            value={`${convertNumberFormat(vehicleDetails?.leasingOptions?.[0]?.leasingExtraMileageCosts)}
        ${t("/vehicleDetails.cents")}`}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.numberOfMonths ? (
          <StyledListItem
            label={t("/vehicleDetails.Duration")}
            value={`${vehicleDetails?.leasingOptions?.[0]?.numberOfMonths} ${t(
              "/vehicleDetails.Months",
            )}`}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.nominalInterestRate ? (
          <StyledListItem
            label={t("/vehicleDetails.Nominal interest rate pa")}
            value={`${vehicleDetails?.leasingOptions?.[0]?.nominalInterestRate?.toLocaleString(currency?.locale)}%`}
            additionalText={t(
              "/vehicleDetails.fixed for the entire contract period",
            )}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.effectiveInterestRate ? (
          <StyledListItem
            label={t("/vehicleDetails.Effective annual interest rate")}
            value={`${vehicleDetails?.leasingOptions?.[0]?.effectiveInterestRate?.toLocaleString(currency?.locale)}%`}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.totalCredit ? (
          <StyledListItem
            label={t("/vehicleDetails.Total Amount")}
            value={convertNumberFormat(
              vehicleDetails?.leasingOptions?.[0]?.totalCredit,
              currency,
            )}
          />
        ) : null}{" "}
        {vehicleDetails?.leasingOptions?.[0]?.leasingDestinationCharges ? (
          <StyledListItem
            label={t("/vehicleDetails.Transfer costs")}
            value={convertNumberFormat(
              vehicleDetails?.leasingOptions?.[0]?.leasingDestinationCharges,
              currency,
            )}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.advancePayment ? (
          <StyledListItem
            label={t("/vehicleDetails.Down payment")}
            value={convertNumberFormat(
              vehicleDetails?.leasingOptions?.[0]?.advancePayment,
              currency,
            )}
          />
        ) : null}
        {vehicleDetails?.leasingOptions?.[0]?.leasingResidualValue ? (
          <StyledListItem
            label={t("/vehicleDetails.Residual Value")}
            value={convertNumberFormat(
              vehicleDetails?.leasingOptions?.[0]?.leasingResidualValue,
              currency,
            )}
          />
        ) : null}
      </ul>
    </>
  );
};
export default LeasingTabView;
